'use strict';

angular.module('far.committee')
    .controller('CommitteeEditController', function ($log, Committee, committeeForm, showModalMessage) {
        var vm = {
            progress: true,
            submitted: false,
            form: {},
            fields: committeeForm,
            constructor: function (committee) {
                    vm.form = Committee.get(committee, function() {
                        vm.progress = false;
                    });



            },
            submit: function () {
                vm.form.save()
                    .then(function (response) {
                        document.location.href=Routing.generate('committee_view', {url: response.data.url});
                    })
                    .catch(function (response) {
                        $log.error(response);
                        showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
                    });
            }
        };

        return vm;
    });